export const formatIndianNumber = (value) => {
  if (value === undefined || value === null) return '';
  const digits = String(value).replace(/\D/g, '');
  if (digits.length <= 3) return digits;
  const lastThree = digits.slice(-3);
  const other = digits.slice(0, -3);
  const formattedOther = other.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
  return `${formattedOther},${lastThree}`;
};

export const convertToLPA = (fullAmount) => {
  if (fullAmount === undefined || fullAmount === null || fullAmount === '')
    return '';
  const numValue =
    typeof fullAmount === 'string' ? parseFloat(fullAmount) : fullAmount;
  if (Number.isNaN(numValue) || numValue === 0) return '';
  return Math.round((numValue / 100000) * 100) / 100;
};

export const convertFromLPA = (lpaValue) => {
  if (lpaValue === undefined || lpaValue === null || lpaValue === '')
    return null;
  const numValue =
    typeof lpaValue === 'string' ? parseFloat(lpaValue) : lpaValue;
  if (Number.isNaN(numValue) || numValue < 0) return null;
  return Math.round(numValue * 100000);
};
